import { KeyboardEvent } from "react";
import { keycloakUtils } from "itsf-ui-common";
import { useHistory, useLocation } from "react-router-dom";
import { URLS } from "@constants";

interface IUseHeaderProps {
    logoutCallback?(): void;
}

export const useHeader = (props?: IUseHeaderProps) => {
    const { logoutCallback } = props ?? {};
    const { push } = useHistory();
    const { pathname } = useLocation();

    const logIn = () => {
        keycloakUtils.login({
            redirectUri: `${window.location.origin}${pathname}`,
        });
    };

    const logOut = () => {
        if (logoutCallback) {
            logoutCallback();
        }

        keycloakUtils.logout({
            redirectUri: `${window.location.origin}`,
        });
    };

    const handleCartClick = () => {
        push(`${URLS.CART_PAGE_URL}`);
    };

    const handleLoginLogout = () => {
        if (keycloakUtils.isAuthenticated()) {
            logOut();
        } else {
            logIn();
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter") {
            handleLoginLogout();
        }
    };

    return {
        logIn,
        logOut,
        handleCartClick,
        handleKeyDown,
        handleLoginLogout,
    };
};
